import React, { useEffect } from 'react';

import optionGroupModule from 'domains/option_groups';
import * as mixedSelectors from 'selectors/mixed';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import CartAddOnOptionGroup from './CartAddOnOptionGroup';

function CartAddOns() {
  const availableCartAddOnGroups = useAppSelector(mixedSelectors.availableOrderOptions);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(optionGroupModule.actions.fetchOrderOptions.pending());
  }, [dispatch]);

  return (
    <div className="cart-addons">
      <div className="addon_options">
        {availableCartAddOnGroups.map((addOnGroup) => (
          <CartAddOnOptionGroup key={addOnGroup.id} group={addOnGroup} />
        ))}
      </div>
    </div>
  );
}

export default CartAddOns;
